import React, { useState } from 'react';
import { 
  FiSearch, 
  FiFilter, 
  FiEye, 
  FiCheck, 
  FiX, 
  FiCalendar, 
  FiFileText, 
  FiMessageSquare,
  FiCornerUpLeft
} from 'react-icons/fi';

const ApplicationMonitoring = () => {
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [showModal, setShowModal] = useState(null);
  const [comment, setComment] = useState('');

  const colors = {
    primary: '#085e53',
    secondary: '#267c77',
    success: '#10b981',
    warning: '#f59e0b',
    error: '#ef4444',
    bg: '#f8fafc'
  };

  const applications = [
    {
      id: 'APP-1001',
      applicant: 'संतोष पाटील',
      type: 'जन्म दाखला',
      gpName: 'इनाम धामणी',
      date: '२०/०२/२०२६',
      status: 'प्रलंबित',
      details: 'मुलाचे नाव: आरव पाटील, जन्म तारीख: १५/०२/२०२६',
      docUrl: 'https://via.placeholder.com/150' 
    },
    {
      id: 'APP-1002',
      applicant: 'सुमन काळे',
      type: 'विवाह नोंदणी',
      gpName: 'बेडग',
      date: '१९/०२/२०२६',
      status: 'मंजूर',
      details: 'वर: राहुल काळे, वधू: प्रिया जाधव',
      docUrl: 'https://via.placeholder.com/150'
    },
    {
      id: 'APP-1003',
      applicant: 'गणेश शिंदे',
      type: 'घरपट्टी आकारणी',
      gpName: 'आरग',
      date: '१८/०२/२०२६',
      status: 'नामंजूर',
      details: 'मिळकत क्र: ४५२/अ, क्षेत्र: १२०० चौ.फूट',
      docUrl: 'https://via.placeholder.com/150'
    }
  ];

  const getStatusBadge = (status) => {
    switch(status) {
      case 'मंजूर': return <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-bold">मंजूर</span>;
      case 'नामंजूर': return <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-bold">नामंजूर</span>;
      default: return <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-bold">प्रलंबित</span>;
    }
  };

  return (
    <div className="p-6 min-h-screen" style={{ backgroundColor: colors.bg }}>
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-1" style={{ color: colors.primary }}>अर्ज निरीक्षण</h1>
        <p className="text-gray-600 text-sm">प्रलंबित आणि मंजूर अर्जांची स्थिती पहा आणि प्रक्रिया करा.</p>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col lg:flex-row gap-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-1">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">ग्रामपंचायत</label>
            <select className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none">
              <option>सर्व निवडा</option>
              <option>इनाम धामणी</option>
              <option>बेडग</option>
              <option>आरग</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">अर्ज प्रकार</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="">सर्व प्रकार</option>
              <option>जन्म दाखला</option>
              <option>मृत्यू दाखला</option>
              <option>विवाह नोंदणी</option>
              <option>घरपट्टी</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">दिनांक</label>
            <input type="date" className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">स्थिती</label>
            <select 
              className="w-full p-2 border rounded-lg bg-gray-50 text-sm focus:ring-2 focus:ring-teal-500 focus:outline-none"
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">सर्व स्थिती</option>
              <option>प्रलंबित</option>
              <option>मंजूर</option>
              <option>नामंजूर</option>
            </select>
          </div>
        </div>
        <button 
          className="px-6 py-2 text-white font-medium rounded-lg shadow-sm hover:opacity-90 transition-opacity self-end"
          style={{ backgroundColor: colors.primary }}
        >
          <FiSearch className="inline mr-2" /> शोधा
        </button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-700 text-sm">
              <th className="p-4 font-semibold border-b">अर्ज क्र.</th>
              <th className="p-4 font-semibold border-b">अर्जदार नाव</th>
              <th className="p-4 font-semibold border-b">ग्रामपंचायत</th>
              <th className="p-4 font-semibold border-b">प्रकार</th>
              <th className="p-4 font-semibold border-b">दिनांक</th>
              <th className="p-4 font-semibold border-b">स्थिती</th>
              <th className="p-4 font-semibold border-b text-center">वस्तूस्थिती</th>
            </tr>
          </thead>
          <tbody className="text-sm divide-y divide-gray-100">
            {applications.map((app) => (
              <tr key={app.id} className="hover:bg-gray-50">
                <td className="p-4 font-mono font-medium text-blue-600">{app.id}</td>
                <td className="p-4 font-medium text-gray-800">{app.applicant}</td>
                <td className="p-4 text-gray-600">{app.gpName}</td>
                <td className="p-4 text-gray-600">
                  <span className="flex items-center gap-1">
                    <FiFileText size={14} className="text-gray-400" />
                    {app.type}
                  </span>
                </td>
                <td className="p-4 text-gray-600 text-xs">
                  <FiCalendar className="inline mr-1 mb-0.5" />
                  {app.date}
                </td>
                <td className="p-4">{getStatusBadge(app.status)}</td>
                <td className="p-4 text-center">
                  <button 
                    onClick={() => setShowModal(app)}
                    className="p-2 rounded-lg hover:bg-teal-50 text-teal-700 transition-colors border border-transparent hover:border-teal-100"
                  >
                    <FiEye size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Detail Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl overflow-hidden flex flex-col max-h-[90vh]">
            <div className="p-5 border-b flex justify-between items-center" style={{ backgroundColor: colors.primary }}>
              <h2 className="text-lg font-bold text-white">
                अर्ज तपशील: {showModal.id}
              </h2>
              <button 
                onClick={() => setShowModal(null)} 
                className="text-white hover:bg-white/20 p-2 rounded-full transition-colors"
              >
                <FiX size={20} />
              </button>
            </div>
            
            <div className="flex-1 overflow-auto p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Left Side: Info */}
                <div className="space-y-6">
                  <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                    <h3 className="font-bold text-gray-800 mb-4 border-b pb-2">अर्जदाराची माहिती</h3>
                    <div className="space-y-3 text-sm">
                      <div className="flex justify-between"><span className="text-gray-500">नाव:</span> <span className="font-medium">{showModal.applicant}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">ग्रामपंचायत:</span> <span className="font-medium">{showModal.gpName}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">अर्ज प्रकार:</span> <span className="font-medium text-teal-700">{showModal.type}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">दिनांक:</span> <span className="font-medium">{showModal.date}</span></div>
                      <div className="flex justify-between"><span className="text-gray-500">सध्याची स्थिती:</span> <span>{getStatusBadge(showModal.status)}</span></div>
                    </div>
                  </div>

                  <div className="bg-blue-50 p-4 rounded-xl border border-blue-100">
                    <h3 className="font-bold text-blue-900 mb-2">अर्जाचा तपशील</h3>
                    <p className="text-blue-800 text-sm">{showModal.details}</p>
                  </div>

                  <div>
                    <label className="block font-medium text-gray-700 mb-2 flex items-center">
                      <FiMessageSquare className="mr-2" /> टिप्पणी / शेरा (Comments)
                    </label>
                    <textarea 
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:outline-none"
                      rows="3"
                      placeholder="येथे टिप्पणी लिहा..."
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    ></textarea>
                  </div>
                </div>

                {/* Right Side: Document Preview (Placeholder) */}
                <div className="flex flex-col h-full">
                  <h3 className="font-bold text-gray-800 mb-3 ml-1">कागदपत्रे (Document Preview)</h3>
                  <div className="flex-1 bg-gray-100 rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center min-h-[300px]">
                    <div className="text-center text-gray-500">
                      <FiFileText size={48} className="mx-auto mb-2 opacity-50" />
                      <p>कागदपत्र पूर्वावलोकन येथे दिसेल</p>
                      <button className="mt-4 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm hover:bg-gray-50 shadow-sm">
                        डाउनलोड करा
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Actions */}
            <div className="p-5 border-t bg-gray-50 flex justify-between items-center">
              <button 
                className="px-5 py-2.5 text-gray-700 bg-white border border-gray-300 rounded-lg font-medium hover:bg-gray-50 shadow-sm flex items-center"
              >
                <FiCornerUpLeft className="mr-2" /> परत पाठवा (Return)
              </button>
              
              <div className="flex gap-3">
                <button 
                  className="px-6 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium shadow-sm transition-colors flex items-center"
                >
                  <FiX className="mr-2" /> नामंजूर करा
                </button>
                <button 
                  className="px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium shadow-sm transition-colors flex items-center"
                >
                  <FiCheck className="mr-2" /> मंजूर करा
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicationMonitoring;
